<!--

Copyright Paul B. Lucas (C) 2025, 2026   ALL RIGHTS RESERVED.
Licensed to the University of Illinois Urbana Champaign

This component is rendered to provide some context valiudation as to why this was created.

Revisions:
    02/25/2025      pblucas     initial creation
    03/21/2026      pblucas     updared text
    

-->
<template>
  <div class="info">
    <h2 class="_h2" >System History</h2>
    <p class="p_01"> This system features a cloud based (Azure) back-end database and application programming interface (API)
        that allows authenticated users to access and retrieve data relevant to asset management and equipment loan agreements.  
        Other applications may access and utilize the asset and loan data utilizing the API.
    </p>
    <h3 class="_h3">System Authentication</h3>
    <p class="p_01"> The API utilizes an Azure APIM key to secure access to the data.  The UX/UI web component utilizes Azure Entra (AD) Authentication
        to fully authenticate users. Users may be classified as regular users (who may need to use the system to request 
        equipment loans) and administrators who need to review all their organizational assets and loan agreements.  Elevated privileges 
        are granted to administrators via membership in Entra (AD) security groups.  Administrators are further restricted to a set 
        of allowed org codes which are granted by system admins.  System administrators are not restricted to org codes and can access 
        all data as well as assign administrative privileges to other users. Privileges and roles are assigned based on membership in the 
        following Entra groups: </p>
    <ul class="ul_01">
      <li>2025 LoanAgreementManager-Admin</li>
      <li>2025 LoanAgreementManager-SysAdmin</li>
      <li>2025 LoanAgreementManager-Receiver</li>
      <li>2025 LoanAgreementManager-Auditor</li>
      <li>2025 LoanAgreementManager-ITSupport</li>

    </ul>      
    <p class="p_01">Org code access is based on user 'home-org' code membership in the 'allowed-orgs' property on the user's employee 
        record.  System administrators have privileged access to 'Settings' and the employee list.  
        Employees have a property named 'allowed-orgs' which is editable by administrators, thus a system administrator can 
        select which orgs a department administrator can access.  General users are presented with limited options when navigating to 
        the application.
    </p>
  
    <p class="p_01">Users with administrative privileges can import assets from prepared Excel spreadsheets, or from spreadsheets exported
      from FabWeb or FabWeb+.   An inference engine attempts to map assets and classify them in accordance with fields available in those 
      data sets.  Inferences use classification sets stored in the /src/configuration/assetTypology.json and /src/configuration/mfgModelMap.json
      files in the application source.   Periodic updates of these files and an application rebuild is required to keep assets properly 
      classified as technology and models change.  (Note:   This is applicable only to imports.  Once assets are imported, new assets can be 
      loaded via the Receiver role.)
    </p>

    <hr>
    <br/>
    <p class="p_01">Special thanks to Ahmed Shim and the Technology Services IAMU group for creating the Avenger test identities needed to test
        this application.

    </p>
    <!-- add these to expose text below the Copyright footer -->
    <br/><br/>

  </div>
</template>


<style scoped>
  .info   {
    max-width: 100%;
    font-family:Monserrat, Avenir, Helvetica, Arial, sans-serif;
    font-weight: normal;
    font-size: 16px;
    padding: 5px;
    margin: 2px auto 2px;
  }
  ._h2 {
    font-size: 14pt;
    text-align: center;
  }
  ._h3 {
    font-size: 12pt;
    text-align: center;
  }
  .ul_01 {
    color: #5c7eb5;
    width: 80%;
    margin: 5px auto;
    padding: 2px;
  }
  li {
    max-width: 90%;
    list-style-type: square;
    font-size: 0.9em;
    font-weight: bold;
    text-align: left;
    margin: 0 10px;
    padding: 0 10px;
  }
  .p_01 {
    max-width: 80%;
    font-size: 0.9em;
    text-align: justify;
    margin: 5px auto;
    padding: 10px;
  }
  ._uiuc_link {
    color: #13294B;
    text-decoration: underline;
  }
  ._uiuc_link:hover {
    color: #FF5F05;
    text-decoration: underline;
  }
</style>
